import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NovaSenha } from '../../../modules/auth/models/nova-senha';
import { UsuarioService } from '../../../modules/auth/services/usuario-service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../modules/auth/services/auth-service';
import { Token } from '../../../modules/auth/models/token';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mudar-senha',
  standalone: false,
  templateUrl: './mudar-senha.component.html',
  styleUrl: './mudar-senha.component.css'
})
export class MudarSenhaComponent {
  @Input() showModal = false;
  @Output() fecharModalPai = new EventEmitter<void>();

  novaSenha = new NovaSenha();
  formMudarSenha: FormGroup;
  token = new Token();

  constructor(
    private usuarioService: UsuarioService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) {
    this.construirFormulario();
    this.token = authService.AccessToken || new Token();
    if (this.token && this.token.email) {
      this.novaSenha.email = this.token.email;
    }
  }

  salvar() {
    this.validarFormulario();
    if (this.formMudarSenha.invalid) {
      this.toastr.error("Formulário inválido, verifique os campos");
      return;
    }

    if (this.formMudarSenha.controls['novaSenha'].value !== this.formMudarSenha.controls['confirmacaoSenha'].value) {
      this.toastr.error("A nova senha e a confirmação não coincidem");
      return;
    }

    Swal.fire({
      title: 'Deseja realmente alterar sua senha?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.preencherModelo();
        this.usuarioService.alterarSenha(this.novaSenha).subscribe(
          (response) => {
            if (response.sucesso) {
              this.toastr.success("Senha alterada com sucesso");
              this.fecharModal();
            } else {
              this.toastr.error("Erro ao alterar senha - " + response.errors[0].mensagem);
            }
          },
          (error) => {
            if (error.status === 500) {
              this.toastr.error(error.error);
            } else if (error.erros && error.erros.length > 0) {
              this.toastr.error(error.erros[0].mensagem);
            } else {
              this.toastr.error("Erro ao alterar senha");
            }
          }
        );
      }
    });
  }

  fecharModal() {
    this.formMudarSenha.reset();
    this.showModal = false;
    this.fecharModalPai.emit();
  }

  onBackgroundClick(event: Event): void {
    this.fecharModal();
  }

  private validarFormulario() {
    Object.keys(this.formMudarSenha.controls).forEach(name => {
      const control = this.formMudarSenha.controls[name];
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();
    });
  }

  private preencherModelo() {
    this.novaSenha.senhaAntiga = this.formMudarSenha.controls['senhaAntiga'].value;
    this.novaSenha.novaSenha = this.formMudarSenha.controls['novaSenha'].value;
    this.novaSenha.confirmacaoSenha = this.formMudarSenha.controls['confirmacaoSenha'].value;
    // Email is already set in constructor
  }

  private construirFormulario() {
    this.formMudarSenha = this.formBuilder.group({
      senhaAntiga: ['', [Validators.required]],
      novaSenha: ['', [Validators.required, Validators.minLength(6)]],
      confirmacaoSenha: ['', [Validators.required]]
    });
  }
}
